import { Button, Input } from "@/atoms";
import { GradientBackground } from "@/components";
import { strings } from "@/constants";
import { GradientVariantEnum, InputTypeEnum } from "@/enums";

export const ResultErrorState = ({
    code,
    errorMessage,
    onReset,
}: {
    code: string,
    errorMessage: string,
    onReset: () => void,
}) => (
    <>
        <GradientBackground variant={GradientVariantEnum.ERROR} />
        <div
            className="
                w-full
                max-w-2xl
                px-4
                text-center
                sm:px-8
            "
        >
            <h1
                className="
                    text-gradient-error
                    mb-2
                    text-2xl
                    font-bold
                    italic
                    sm:text-3xl
                "
            >
                {errorMessage || strings.code.errorDefault}
            </h1>
            <span className="mb-8 block text-text-muted">{strings.code.errorSubtitle}</span>
            <div
                className="
                    flex
                    flex-col
                    items-center
                    justify-center
                    gap-4
                    sm:flex-row
                "
            >
                <div className="w-full max-w-md sm:flex-1">
                    <Input
                        type={InputTypeEnum.TEXT}
                        value={code}
                        disabled
                        hasError
                    />
                </div>
                <Button onClick={onReset}>{strings.code.buttonReenter}</Button>
            </div>
        </div>
    </>
);
